import { HpaBottomRow } from "../Components/Atoms/ProductBottomRows";

export const productCardBottomRows = {
    hpa: HpaBottomRow,
};
